export const DEMO_SCHEDULING_URL = "https://calendly.com/colindarke-complisun/30min";


export const INSTALL_FEE = 4000;
export const PLATFORM_MONTHLY = 1000;
export const PER_SEAT_YR = 30;
export const HOURLY = 150;

export const INCLUDED = [
  { label: "Single source of truth", sub: "policies, procedures, agreements & the compliance manual — versioned" },
  { label: "Issue & case management", sub: "log, assign, remediate, evidence — full audit trail" },
  { label: "Monitoring & Testing", sub: "forensic tests, quarterly program, 206(4)-7 annual review" },
  { label: "Regulatory filings & calendar", sub: "Form ADV, CRS, U4, IAR registrations — deadlines owned" },
  { label: "CompliMind + Expert Prompts", sub: "AI inside your environment, validated by practitioners" },
  { label: "Marketing review", sub: "Marketing Rule — performance, testimonials, substantiation" },
  { label: "Code of Ethics", sub: "personal trading, pre-clearance, restricted lists, attestations" },
  { label: "OBAs, political contributions & conflicts", sub: "disclosures tracked, attested, reported" },
  { label: "Risk assessment & annual review tools", sub: "adviser-specific, linked to policies and tests" },
  { label: "Cybersecurity program", sub: "technology inventory, incident reporting, awareness training" },
  { label: "Training for every employee", sub: "role-based courses, quizzes, attestations" },
  { label: "Monthly 1-hour check-in", sub: "with your dedicated compliance expert" },
];

export const ADDONS = [
  { key: "vendor", label: "Vendor Management", monthly: 250, specialist: "Named Compliance Specialist", defHours: 4,
    sub: "Custodian, sub-adviser, technology and data-vendor due diligence with ongoing attestations — a named specialist on our team runs the reviews with you." },
  { key: "onboarding", label: "Client Onboarding", monthly: 250, specialist: "Named Onboarding Specialist", defHours: 4,
    sub: "Advisory agreements, suitability / KYC documentation, account-opening checks and Form CRS delivery — handled by a named person on our team." },
];

export const CADENCES = [
  { key: "monthly",  label: "Monthly",   monthly: 0,   sub: "1-hour check-in · included" },
  { key: "biweekly", label: "Bi-weekly", monthly: 150, sub: "+1 meeting/mo · $150/hr" },
  { key: "weekly",   label: "Weekly",    monthly: 450, sub: "+3 meetings/mo · $150/hr" },
];

export const PLANS = [
  { key: "platform", label: "Platform",            addons: [],                      sub: "Everything included · monthly check-in", },
  { key: "vendor",   label: "Platform + Vendor Management", addons: ["vendor"],     sub: "Adds vendor DD run by a named specialist" },
  { key: "complete", label: "Complete",            addons: ["vendor", "onboarding"], sub: "Both add-ons · two named specialists" },
];

export const ROLES = [
  { key: "cco",        label: "Fractional CCO",              rate: 400, discountable: true,  min: 2, max: 60, def: 10, sub: "named CCO or co-CCO — owns the program and sits across from the SEC" },
  { key: "director",   label: "Director of Compliance",      rate: 300, discountable: true,  min: 2, max: 60, def: 10, sub: "owns the program day to day and drives the build" },
  { key: "counsel",    label: "Regulatory / Exam Counsel",   rate: 200, discountable: true,  min: 2, max: 60, def: 10, sub: "exam prep, document requests, deficiency-letter responses" },
  { key: "bsa",        label: "BSA/AML Officer",             rate: 200, discountable: true,  min: 2, max: 60, def: 10, sub: "FinCEN's RIA AML rule lands in 2028 — be ready before it does" },
  { key: "specialist", label: "Compliance Specialist",       rate: 175, discountable: true,  min: 2, max: 80, def: 10, sub: "monitoring, testing, screening review, and issue follow-through" },
  { key: "analyst",    label: "Compliance Analyst",          rate: 150, discountable: true,  min: 2, max: 80, def: 10 },
  { key: "admin",      label: "Admin / Ops & Tech Support",  rate: 75,  discountable: false, min: 2, max: 80, def: 10 },
];

export const commitDiscount = (hours) => (hours >= 40 ? 20 : hours >= 20 ? 15 : hours >= 10 ? 10 : 0);
export const fmt = (n) => `$${Math.round(n).toLocaleString()}`;
